<script setup lang="ts">
import { useElementSize } from '@vueuse/core';

definePageMeta({
  layout: 'blank',
});

const footerEl = ref<HTMLElement | null>(null);

const { height: footerHeight } = useElementSize(
  footerEl,
  { height: 0, width: 0 },
  { box: 'border-box' },
);

watch(footerHeight, (newHeight) => {
  console.debug('🚀 ~ Footer Height:', newHeight);

  window.parent.postMessage(
    JSON.stringify({ type: 'iframeHeight', height: newHeight }),
    '*',
  );
});

onBeforeRouteLeave((to) => {
  if (to.fullPath.includes('/_/footer')) return;

  try {
    if (window.top) {
      console.debug('🚀 ~ window.top:', to);
      window.top.location.href = to.fullPath;

      return;
    }
  } catch (error) {
    console.error('🚀 ~ window.top error:', error);
  }

  try {
    if (window.parent) {
      console.debug('🚀 ~ window.parent:', to);
      window.parent.location.href = to.fullPath;

      return;
    }
  } catch (error) {
    console.error('🚀 ~ window.parent error:', error);
  }

  try {
    if (window.open) {
      console.debug('🚀 ~ window.open:', to);
      window.open(to.fullPath, '_blank');

      return;
    }
  } catch (error) {
    console.error('🚀 ~ window.open error:', error);
  }

  console.debug('🚀 ~ end:', to);
});
</script>

<template>
  <Footer ref="footerEl" />
</template>
